import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";

import { BrowserAuthedApp } from "@src/App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<BrowserAuthedApp />);
Modal.setAppElement("#root");
